import { Card, Checkbox, FormControlLabel, Icon, Stack, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { displayDate } from "utils/Date";

function ReportActionWrapper({
  reportData,
  showPreviousAnswersField = false,
  showPreviousAnswers,
  setShowPreviousAnswers,
  children,
}) {
  const loginUserState = useSelector((state) => state.loginUser.loginUserState);
  return (
    <Card sx={{ width: "100%", height: "100%", p: 2 }}>
      <Grid container justifyContent="space-between">
        <Grid item display="inline-flex" xs={12} sm={6}>
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="4rem"
            height="4rem"
            variant="gradient"
            bgColor="primary"
            color="white"
            shadow="md"
            borderRadius="xl"
            ml={3}
            mt={-4}
          >
            <Icon fontSize="medium" color="inherit">
              quiz
            </Icon>
          </MDBox>
          <Stack mt={-1} mb={1} ml={2}>
            <MDTypography variant="h6">{reportData?.CoachupTemplate?.name}</MDTypography>
            <MDTypography variant="caption" sx={{ fontSize: "14px", color: "#808080" }}>
              {displayDate(moment.tz(reportData?.dueDate, loginUserState.timezone))}
            </MDTypography>
          </Stack>
        </Grid>
        {showPreviousAnswersField ? (
          <MDBox xs={12} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showPreviousAnswers}
                  onChange={(_, checked) => setShowPreviousAnswers(checked)}
                />
              }
              label="Show previous answers"
            />
          </MDBox>
        ) : null}
      </Grid>
      <MDBox>{children}</MDBox>
    </Card>
  );
}

export default ReportActionWrapper;
